// Generated from SVG to Code Figma Plugin

export const BaseLineCheck3 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.6667 22C15.4281 22 17.9281 20.8807 19.7378 19.0711C21.5474 17.2614 22.6667 14.7614 22.6667 12C22.6667 9.2386 21.5474 6.7386 19.7378 4.92893C17.9281 3.11929 15.4281 2 12.6667 2C9.90535 2 7.40535 3.11929 5.59568 4.92893C3.78604 6.7386 2.66675 9.2386 2.66675 12C2.66675 14.7614 3.78604 17.2614 5.59568 19.0711C7.40535 20.8807 9.90535 22 12.6667 22Z"
      fill="#0086FF"
    />
    <path
      d="M8.66675 12L11.6667 15L17.6667 9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
